module.exports = __webpack_public_path__ + "static/media/1POLICY17.426c5393.jpg";